import { useState, useEffect, useCallback } from 'react'

export const useIsHydrated = () => {
    const [isHydrated, setIsHydrated] = useState(false)
    
    useEffect(() => {
        setIsHydrated(true)
    }, [])
    
    return isHydrated
}

export const ClientOnly = ({ children, fallback = null }) => {
    const isHydrated = useIsHydrated()
    
    if (!isHydrated) {
        return fallback
    }
    
    return children
}

/**
 * react-slick sets aria-hidden="true" on inactive slides but leaves focusable
 * descendants (elements with tabindex) inside them. Lighthouse flags this as an
 * accessibility violation. This hook returns a callback ref that watches for
 * aria-hidden changes and applies the `inert` attribute to hidden slides,
 * preventing them from receiving focus or interaction without affecting layout.
 */
export const useSlickA11yFix = () => {
    return useCallback((node) => {
        if (!node) return
        const fix = () => {
            node.querySelectorAll('.slick-slide[aria-hidden="true"]').forEach(slide => {
                slide.setAttribute('inert', '')
            })
            node.querySelectorAll('.slick-slide[aria-hidden="false"]').forEach(slide => {
                slide.removeAttribute('inert')
            })
        }
        fix()
        const observer = new MutationObserver(fix)
        observer.observe(node, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] })
        return () => observer.disconnect()
    }, [])
}
